import { type IDBPObjectStore, openDB } from 'idb';

export const DB_NAME = 'quesmed-admin-db';
export const DB_VERSION = 1;

export const tables = [
  {
    name: 'failed_records',
    keyPath: 'id',
    indexes: [
      { name: 'jobId', keyPath: 'jobId', options: { unique: false } },
      { name: 'type', keyPath: 'type', options: { unique: false } },
      { name: 'timestamp', keyPath: 'timestamp', options: { unique: false } },
    ],
  },
  // add new tables here
];

export const dbPromise = openDB(DB_NAME, DB_VERSION, {
  upgrade(db, _oldVersion, _newVersion, transaction) {
    for (const table of tables) {
      let store: IDBPObjectStore<unknown, ArrayLike<string>, string, 'versionchange'>;

      if (!db.objectStoreNames.contains(table.name)) {
        store = db.createObjectStore(table.name, {
          keyPath: table.keyPath,
        });
      } else {
        store = transaction.objectStore(table.name);
      }

      for (const index of table.indexes) {
        if (!store.indexNames.contains(index.name)) {
          store.createIndex(index.name, index.keyPath, index.options);
        }
      }
    }
  },
});
